import { atom } from 'recoil';
import { ActionBarType } from 'common/actionBar/types/actionBar';

export const actionBarAtom = atom<ActionBarType>({
  key: 'actionBarAtom',
  default: {
    isOpen: false,
    inputs: null
  }
});
